<template>
  <div class="wrapper">
    <div class="image-container">
      <img @load="onImageLoad" @error="onImageError" :src="imgBase64" alt="image" class="image" :style="{ maxWidth: imgWidth, height: 'auto' }" />
    </div>
    <button v-if="showCloseButton" class="close-btn" @click.prevent="closeImage">
      <span>X</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "ImageRender",
  props: {
    imgBase64: {
      type: String,
      required: true
    },
    imgWidth: {
      type: String,
      default: "208px" // Default width
    },
    imgHeight: {
      type: String,
      default: "auto" // Default height
    },
    width: {
      type: String || Number,
      default: 0 // Default width
    },
    height: {
      type: String || Number,
      default: 0 // Default height
    },
    showCloseButton: {
      type: Boolean,
      default: true // Default value
    }
  },
  data() {
    return {
      imageRenders : false
    };
  },
  methods: {
    closeImage() {
      this.$emit('close'); // Assuming parent component will handle the close event
    },
    onImageLoad(){
      this.imageRenders = true
    },
    onImageError(){
      this.imageRenders = false
    }
  }
};
</script>

<style scoped>
/* Wrapper to position button outside */
.wrapper {
  position: relative;
  display: inline-block;
}

/* Image container */
.image-container {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  border-radius: 5px;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.3);
}

/* Image */
.image {
  display: block;
  border-radius: 5px;
  width: 100%;
  height: 100%; /* Fill the container height */
  object-fit: cover; /* Center crop the image */
  object-position: center; /* Center the image for cropping */
  transition: all 0.3s ease-in-out;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.3);
}

/* Close button positioned completely outside */
.close-btn {
  position: absolute;
  top: -9%;
  right: -4%;
  background-color: #dee0df;
  color: white;
  border: none;
  border-radius: 50%;
  width: 11%; /* Adjusts based on image width */
  aspect-ratio: 1 / 1; /* Keeps button square */
  min-width: 15px;
  min-height: 15px;
  font-size: 11px;
  font-family: Gothic A1, sans-serif;
  font-weight: bold;
  cursor: pointer;
  transition: box-shadow 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Button hover effect */
.close-btn:hover {
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.4);
}
</style>
